import React, { FC, useContext, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../../context/auth';
import { retrieveToken } from '../../utils/refetch';

const PrivateRoute: FC = () => {
  const authContext = useContext(AuthContext);

  const { isAuthenticated, loading, logout } = authContext;
  useEffect(() => {
  }, [isAuthenticated]);

  if (loading) return null;
  if (!retrieveToken()) {
    logout();
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
